var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "page"
  }, [_c('div', {
    staticClass: "pointes-list"
  }, [_c('div', {
    staticClass: "page__title"
  }, [_vm._v(" " + _vm._s(_vm.getModuleConfig("expiring_page.form_title")) + " ")]), _vm.getModuleConfig('expiring_page.form_desc') ? _c('div', {
    staticClass: "page__desc",
    domProps: {
      "innerHTML": _vm._s(_vm.getModuleConfig('expiring_page.form_desc'))
    }
  }) : _vm._e(), _vm.getModuleConfig('expiring_page.content') ? _c('div', {
    staticClass: "page__content",
    domProps: {
      "innerHTML": _vm._s(_vm.getModuleConfig('expiring_page.content'))
    }
  }) : _vm._e(), _c('ExpiringPointLogs', {
    attrs: {
      "event-code": _vm.eventCode,
      "field-setting": _vm.getModuleConfig('expiring_page.field_setting')
    }
  })], 1)]);
}
var staticRenderFns = []

export { render, staticRenderFns }